/**
 * Get CSS variable value from the root element
 * @param {string} variableName - CSS variable name (e.g., '--skeleton-base-color')
 * @returns {string} - The computed value of the CSS variable
 */
const getCSSVariable = (variableName) => {
  if (typeof window === "undefined") {
    // Fallback for SSR
    return getDefaultColor(variableName);
  }

  const root = document.documentElement;
  const value = getComputedStyle(root).getPropertyValue(variableName).trim();

  // If variable is not found, return default color
  if (!value) {
    return getDefaultColor(variableName);
  }

  return value;
};

/**
 * Get default color fallback if CSS variable is not available
 * @param {string} variableName - CSS variable name
 * @returns {string} - Default color value
 */
const getDefaultColor = (variableName) => {
  const defaults = {
    "--skeleton-base-color": "#1b2047",
    "--skeleton-highlight-color": "#040721",
  };
  return defaults[variableName] || "#1b2047";
};

// Export functions that read from CSS variables (theme-aware)
export const baseColor = () => getCSSVariable("--skeleton-base-color");
export const highlightColor = () =>
  getCSSVariable("--skeleton-highlight-color");

// Also export as direct values for backward compatibility (will use current theme)
// These are getter functions that return the current theme's color
export const getBaseColor = baseColor;
export const getHighlightColor = highlightColor;
